import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ICurrencySettings } from '../checkout/currency-settings.model';

/**
 * Fetch the required ICurrencySettings from `this.checkoutService.getCurrencySettings()`
 */
@Pipe({
  name: 'venueCurrency'
})
export class VenueCurrencyPipe implements PipeTransform {
  currencyPipe = new CurrencyPipe('en');

  /**
   * Uses the angular currency pipe to take the ICurrencySettings object and transform with venues currencyCode symbol and fraction size.
   * @param value number value, e.g. 12.3
   * @param curr Currency Settings from venueConfig.venueSettings
   * @returns string in the correct format, $12.33.
   */
  transform(value: number | undefined, curr: ICurrencySettings | undefined): string | null {
    if (value === undefined || isNaN(value)) {
      value = 0;
    }

    if (!curr || !curr.currencyCode || !curr.currencySymbol || !curr.currencyFractionSize) {
      return '';
    }

    return this.currencyPipe.transform(value, curr.currencyCode, curr.currencySymbol, curr.currencyFractionSize);
  }
}
